
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class WorkflowMapDialog extends SiteEntityDialog<WorkflowMapRow, any> {
        protected getFormKey() { return WorkflowMapForm.formKey; }
        protected getIdProperty() { return WorkflowMapRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowMapRow.localTextPrefix; }
        protected getNameProperty() { return WorkflowMapRow.nameProperty; }
        protected getService() { return WorkflowMapService.baseUrl; }

        protected form = new WorkflowMapForm(this.idPrefix);

    }
}